import { css } from '@emotion/react';

export const BaseDownloadContainer = css`
  margin-top: 1.875rem;
  display: flex;
  justify-content: center;
  margin-left: 5px;
`;
